module.exports = require("react");


//////////////////
// WEBPACK FOOTER
// external "react"
// module id = 20
// module chunks = 0